import api from './axiosConfig';

// Auth — getUserByToken matches AuthController @GetMapping("/getUserByToken") (permitAll; token in query).
export const authAPI = {
  signIn: (data) => api.post('/api/v1/auth/sign-in', data),
  signUp: (data) => api.post('/api/v1/auth/sign-up', data),
  getUserByToken: (token) =>
    api.get(`/api/v1/auth/getUserByToken?token=${encodeURIComponent(token)}`),
};

// Sport Types
export const sportTypeAPI = {
  getAll: () => api.get('/api/v1/sport-types/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/sport-types/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/sport-types/${id}`),
  add: (data) => api.post('/api/v1/sport-types/add', data),
  update: (id, data) => api.put(`/api/v1/sport-types/update/${id}`, data),
  delete: (id) => api.delete(`/api/v1/sport-types/delete/${id}`),
};

// FAQs
export const faqAPI = {
  getAll: () => api.get('/api/v1/faqs/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/faqs/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/faqs/${id}`),
  add: (data) => api.post('/api/v1/faqs/add', data),
  update: (id, data) => api.put(`/api/v1/faqs/update/${id}`, data),
  delete: (id) => api.delete(`/api/v1/faqs/delete/${id}`),
};

// About Us
export const aboutUsAPI = {
  getAll: () => api.get('/api/v1/about-us/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/about-us/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/about-us/${id}`),
  add: (data) => api.post('/api/v1/about-us/add', data),
  update: (id, data) => api.put(`/api/v1/about-us/update/${id}`, data),
  delete: (id) => api.delete(`/api/v1/about-us/delete/${id}`),
};

// Events
export const eventAPI = {
  getAll: () => api.get('/api/v1/events/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/events/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/events/${id}`),
  add: (data) => api.post('/api/v1/events/add', data),
  update: (id, data) => api.put(`/api/v1/events/update/${id}`, data),
  delete: (id) => api.delete(`/api/v1/events/delete/${id}`),
};

// Gyms
export const gymAPI = {
  getAll: () => api.get('/api/v1/gyms/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/gyms/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/gyms/${id}`),
  add: (data) => api.post('/api/v1/gyms/add', data),
  update: (id, data) => api.put(`/api/v1/gyms/update/${id}`, data),
  delete: (id) => api.delete(`/api/v1/gyms/delete/${id}`),
};

// Requests
export const requestAPI = {
  getAll: () => api.get('/api/v1/requests/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/requests/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/requests/${id}`),
  add: (data) => api.post('/api/v1/requests/add', data),
  update: (id, data) => api.put(`/api/v1/requests/update/${id}`, data),
  delete: (id) => api.delete(`/api/v1/requests/delete/${id}`),
};

// Trainers
export const trainerAPI = {
  getAll: () => api.get('/api/v1/trainers/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/trainers/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/trainers/${id}`),
  add: (data) => api.post('/api/v1/trainers/add', data),
  update: (id, data) => api.put(`/api/v1/trainers/update/${id}`, data),
  delete: (id) => api.delete(`/api/v1/trainers/delete/${id}`),
};

// Achievements
export const achievementAPI = {
  getAll: () => api.get('/api/v1/achievements/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/achievements/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/achievements/${id}`),
  add: (data) => api.post('/api/v1/achievements/add', data),
  update: (id, data) => api.put(`/api/v1/achievements/update/${id}`, data),
  delete: (id) => api.delete(`/api/v1/achievements/delete/${id}`),
};

// Comments
export const commentAPI = {
  getAll: () => api.get('/api/v1/comments/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/comments/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/comments/${id}`),
  add: (data) => api.post('/api/v1/comments/add', data),
  update: (id, data) => api.put(`/api/v1/comments/${id}`, data),
  delete: (id) => api.delete(`/api/v1/comments/${id}`),
};

// Groups
export const groupAPI = {
  getAll: () => api.get('/api/v1/groups/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/groups/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/groups/${id}`),
  add: (data) => api.post('/api/v1/groups/add', data),
  update: (id, data) => api.put(`/api/v1/groups/update/${id}`, data),
  delete: (id) => api.delete(`/api/v1/groups/delete/${id}`),
};

// Students
export const studentAPI = {
  getAll: () => api.get('/api/v1/students/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/students/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/students/${id}`),
  add: (data) => api.post('/api/v1/students/add', data),
  update: (id, data) => api.put(`/api/v1/students/update/${id}`, data),
  delete: (id) => api.delete(`/api/v1/students/delete/${id}`),
};

// Enrolments
export const enrolmentAPI = {
  getAll: () => api.get('/api/v1/enrolments/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/enrolments/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/enrolments/${id}`),
  add: (data) => api.post('/api/v1/enrolments/add', data),
  update: (id, data) => api.put(`/api/v1/enrolments/update/${id}`, data),
  delete: (id) => api.delete(`/api/v1/enrolments/delete/${id}`),
};

// Lessons
export const lessonAPI = {
  getAll: () => api.get('/api/v1/lessons/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/lessons/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/lessons/${id}`),
  add: (data) => api.post('/api/v1/lessons/add', data),
  update: (id, data) => api.put(`/api/v1/lessons/update/${id}`, data),
  delete: (id) => api.delete(`/api/v1/lessons/delete/${id}`),
  getAttendanceSheet: (id) => api.get(`/api/v1/lessons/${id}/attendance-sheet`),
  saveBulkAttendance: (id, data) => api.post(`/api/v1/lessons/${id}/attendance-bulk`, data),
};

// Attendances
export const attendanceAPI = {
  getAll: () => api.get('/api/v1/attendances/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/attendances/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/attendances/${id}`),
  add: (data) => api.post('/api/v1/attendances/add', data),
  update: (id, data) => api.put(`/api/v1/attendances/update/${id}`, data),
  delete: (id) => api.delete(`/api/v1/attendances/delete/${id}`),
};

// Training Schools
export const trainingSchoolAPI = {
  getAll: () => api.get('/api/v1/training-schools/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/training-schools/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/training-schools/${id}`),
  add: (data) => api.post('/api/v1/training-schools/add', data),
  update: (id, data) => api.put(`/api/v1/training-schools/update/${id}`, data),
  delete: (id) => api.delete(`/api/v1/training-schools/delete/${id}`),
};

// Media
export const mediaAPI = {
  upload: (file, type) => {
    const formData = new FormData();
    formData.append('media', file);
    formData.append('mediaType', type);
    return api.post('/api/medias/upload-media', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  delete: (mediaId) => api.delete(`/api/medias/delete-media/${mediaId}`),
};

// Transactions
export const transactionAPI = {
  getAll: () => api.get('/api/v1/transactions/list'),
  getPage: (page = 0, size = 10) => api.get(`/api/v1/transactions/page?page=${page}&size=${size}`),
  getById: (id) => api.get(`/api/v1/transactions/${id}`),
  add: (data) => api.post('/api/v1/transactions/add', data),
  update: (id, data) => api.put(`/api/v1/transactions/update/${id}`, data),
  delete: (id) => api.delete(`/api/v1/transactions/delete/${id}`),
};
